import {Hub, TimerStickerValue} from 'yougile-model'

export const getTimerValue = (task: Hub): TimerStickerValue => {
  return {
    current: {
      time: '',
      by: undefined,
      running: true,
      timestamp: task.timestamp
    },
    history: []
  }
}
